/**
 * Form validation utilities
 */

/**
 * Validate email format. Email is OPTIONAL — empty values are accepted.
 * Only the format is checked when a value is supplied.
 */
export const validateEmail = (email) => {
    if (!email || !email.trim()) {
        return '';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        return 'Invalid email format';
    }

    return '';
};

/**
 * Validate required text field
 */
export const validateRequired = (value, fieldName) => {
    if (!value || !value.trim()) {
        return `${fieldName} is required`;
    }
    return '';
};



/**
 * Validate all booking form fields
 */
export const validateBookingForm = (formData) => {
    const errors = {};

    const firstNameError = validateRequired(formData.first_name, 'First name');
    if (firstNameError) errors.first_name = firstNameError;

    const lastNameError = validateRequired(formData.last_name, 'Last name');
    if (lastNameError) errors.last_name = lastNameError;

    const emailError = validateEmail(formData.email);
    if (emailError) errors.email = emailError;

    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
};
